import React, { Component } from 'react';
import * as extra from '../extra';



export default class Auth extends React.Component {

    constructor(props) {
        super(props);

        this.inputLogin = this.inputLogin.bind(this);
        this.inputPassword = this.inputPassword.bind(this);
        this.submit = this.submit.bind(this);
        this.input = this.input.bind(this);
        this.showStatus = this.showStatus.bind(this);

        this.state = {
            login: '',
            password: '',
            role: '',
            status: ''
        };
    };

    inputLogin(e) {
        this.setState({ login: e.target.value });
    }

    inputPassword(e) {
        //e.preventDefault();
        this.setState({ password: e.target.value });
    }

    input(login, password, role){
      this.setState({
          login: login,
          password: password,
          role: role
      })
      this.props.logIn(this.state.login, this.state.password, role);
    }

    submit(){
        let res = extra.api('auth', [this.state.login, this.state.password]);

        //неверный логин/пароль
        if( res == 0){
            this.showStatus('попробуйте другой логин/пароль', 5000);
        } else {
            res = JSON.parse(res);
            let fio = res[0];
            let role = res[1];

            //список баллов
            if( role == 'point' ){
                let url = "http://pps.istu.ru/api/listPoint.php";
                //url = extra.fixedEncodeURIComponent(url);
                //console.log(url);
                window.location.href = url;
            } else if( (fio !== 'Преподаватель') && (role == 'prep') ){ //если конкретный преподаватель
                let url = "http://pps.istu.ru/api/card.php?fio="+fio;
                window.location.href = url;
            } else {
                this.setState({
                    role: role
                })
                this.props.logIn(this.state.login, this.state.password, role);
            }
        }

        //console.log(role);
    }

    showStatus(text, time){
      this.setState({
        status: text
      })
      setTimeout(() => {
        this.setState({
          status: ''
        })
      }, time)
    }

  render() {
    return (
        <div className='auth'>

            <div className='instruction-block'>
            {/*<div className='one-pt title'>Личный кабинет откроется в скором времени</div>*/}
              {/*<div className='one-pt title'>
                    <div className='link' onClick={ () => this.input('prep','prep','prep')}>Перейти к заполнению Индивидуального портфолио ППС</div>
                  <div className='close-link'>Прием данных к Индивидуального портфолио ППС закончен</div>
              </div>*/}
            </div>
            <div className='auth-block'>
              <div className='title'>Авторизация</div>
              <div className='status'>{this.state.status}</div>
              {/*<div className='link' onClick={ () => this.input('libr','libr','libr')}>Научная библиотека</div>
              <div className='link' onClick={ () => this.input('econ','econ','econ')}>Экономисты</div>*/}

                <form onSubmit={this.handleSubmit}>
                  <input
                    onChange={this.inputLogin}
                    value={this.state.login}
                    placeholder='Логин'
                  />
                  <input
                    onChange={this.inputPassword}
                    value={this.state.password}
                    placeholder='Пароль'
                    type='password'
                  />
                  <div onClick={this.submit} className='login-button'>
                    Войти
                  </div>
                </form>
            </div>

        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Auth.js